// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__GiITo","footer":"ChangeClinic_footer__1z9dC"};